import { formatNumberValue } from '../../../common/numberFormat';
import { compactNumber } from '../../../v2/shared/utils/numberUtils';

// Resolve by identity only: matching labels can belong to different units.
export const formatHeatmapMetric = (
  metric = {},
  configured = {},
  fields = [],
  compact = false
) => {
  if ((metric.has_data ?? metric.hasData) === false) return 'Not populated';
  const value = metric.total;
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    !['number', 'string'].includes(typeof value) ||
    (typeof value === 'string' && !value.trim()) ||
    !Number.isFinite(Number(value))
  )
    return '-';
  const calc = metric.calc || configured.calc;
  const fieldId =
    metric.field_id !== undefined ? metric.field_id : configured.field_id;
  const field = fields.find((item) => item.id === fieldId);
  const config = calc === 'count' ? {} : field?.config || {};
  if (config.format || config.decimal_places !== undefined)
    return formatNumberValue(
      value,
      compact && config.format === 'percentage'
        ? { ...config, decimal_places: Math.min(config.decimal_places ?? 0, 2) }
        : config,
      undefined,
      { compact }
    );
  return compact
    ? String(compactNumber(Number(value), 0))
    : Number(value).toLocaleString();
};
